import { useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useGetBrokerMaster } from 'views/components/pages/accountEstablishment/hooks';
import {
  DepositAccountFormikType,
  depositAccountInfoValidation,
  depositAccountInfoInitialValues,
  depositAccountInfoOnSubmit,
} from 'views/utils/accountEstablish';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore } from './useUpdatePage';

export const useDepositAccountUpdate = () => {
  const { param, add } = useAccountInfoUpdateStore();

  const { bankMaster, getBankMaster } = useGetBrokerMaster(param.bankCode, param.branchCode);

  const initialValues = depositAccountInfoInitialValues(
    param,
    bankMaster.data?.GetBrokerMaster?.BrokerName,
    bankMaster.data?.GetBrokerMaster?.BranchName,
  );

  const onSubmit = depositAccountInfoOnSubmit<AccountInfoUpdateRequestParam>(param, add);

  const formik: DepositAccountFormikType = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: depositAccountInfoValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  useEffect(() => {
    if (formik.values.bankCode === '' && formik.values.branchCode === '') return;

    // GetAccountDetailInfoで金融機関名と支店名が取れないので、GetBrokerMasterで取得する
    getBankMaster();
  }, [
    formik.values.bankCode,
    formik.values.bankName,
    formik.values.branchCode,
    formik.values.branchName,
    getBankMaster,
  ]);

  return {
    formik,
  };
};
